$(() =>
  $("#trigger--all_check").on("click", function () {
    $("input[type='checkbox']").prop("checked", this.checked);
  })
);
